import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useTranslation } from "../../hooks/useTranslation";
import "../../styles/OurUlcTeam.css";

// Import team member images
// import samirImg from "../../assets/all-images/team1.jpg"; // Replace with actual image
// import aliImg from "../../assets/all-images/team2.jpg"; // Replace with actual image
import muhammadImg from "../../assets/all-images/team9.jpg";

const OurUlcTeam = () => {
  const t = useTranslation();

  const teamMembers = [
    {
      id: 1,
      name: t("team.members.samir.name"),
      position: t("team.members.samir.position"),
      image: null,
      bioKey: "team.bio.managingDirector",
      expertise: [
        "team.expertise.strategy",
        "team.expertise.leadership",
        "team.expertise.engineering",
        "team.expertise.operations",
      ],
      social: {
        linkedin: "#",
        twitter: "#",
        email: "#",
      },
    },
    {
      id: 2,
      name: t("team.members.ali.name"),
      position: t("team.members.ali.position"),
      image: null,
      bioKey: "team.bio.ceo",
      expertise: [
        "team.expertise.management",
        "team.expertise.finance",
        "team.expertise.growth",
        "team.expertise.innovation",
      ],
      social: {
        linkedin: "#",
        twitter: "#",
        email: "#",
      },
    },
    // {
    //   id: 3,
    //   name: t("team.members.muhammad.name"),
    //   position: t("team.members.muhammad.position"),
    //   image: muhammadImg,
    //   bioKey: "team.bio.cmo",
    //   expertise: [
    //     "team.expertise.branding",
    //     "team.expertise.digital",
    //     "team.expertise.communications",
    //     "team.expertise.strategy",
    //   ],
    //   social: {
    //     linkedin: "#",
    //     twitter: "#",
    //     email: "#",
    //   },
    // },
  ];

  return (
    <section className="team-section" id="team">
      <Container>
        <Row className="mb-5">
          <Col lg="12" className="text-center">
            <h6 className="section__subtitle">{t("team.subtitle")}</h6>
            <h2 className="section__title">{t("team.title")}</h2>
            <p className="section__description">{t("team.description")}</p>
          </Col>
        </Row>

        <Row className="g-4 justify-content-center">
          {teamMembers.map((member) => (
            <Col lg="4" md="6" key={member.id} className="team-member-col">
              <div className="team__card">
                <div className="team__image-wrapper">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={member.name}
                      className="team__image"
                    />
                  ) : (
                    <div className="team__placeholder">
                      <i className="ri-user-3-line"></i>
                    </div>
                  )}
                  <div className="team__social-overlay">
                    <a href={member.social.linkedin} aria-label="LinkedIn">
                      <i className="ri-linkedin-fill"></i>
                    </a>
                    <a href={member.social.twitter} aria-label="Twitter">
                      <i className="ri-twitter-fill"></i>
                    </a>
                    <a href={member.social.email} aria-label="Email">
                      <i className="ri-mail-fill"></i>
                    </a>
                  </div>
                </div>

                <div className="team__content">
                  <div className="team__header">
                    <h3 className="team__name">{member.name}</h3>
                    <p className="team__position">{member.position}</p>
                  </div>

                  <div className="team__divider">
                    <div className="divider-line"></div>
                    <i className="ri-building-2-line"></i>
                    <div className="divider-line"></div>
                  </div>

                  <div className="team__expertise">
                    <ul>
                      {member.expertise.map((exp, index) => (
                        <li key={index}>
                          <i className="ri-checkbox-circle-line"></i> {t(exp)}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default OurUlcTeam;
